<template lang="pug">
md-list.instituciones-list(:md-expand-single='true' ref="toscroll")
  md-list-item#escuelas(md-expand :md-expanded.sync="expandEscuelas")
    span.md-list-item-text Instituciones Educativas
    md-list(slot='md-expand')
      div(@click="$event.stopPropagation()")
        md-list
          template(v-for="item in escuelas")
            md-list-item.escuela(
              ref="escuelaItems"
              :key="`escuela-${item.id}`"
              :id="`escuela-${item.id}`"
              :class="item.id === institucionId ? 'selected' : ''"
              @click="setInstitucionAndUpdateRoute({ institucion: item, })")
              Institucion(:object="item")
            md-divider
  md-list-item#hospitales(md-expand :md-expanded.sync="expandHospitales")
    span.md-list-item-text Instituciones de Salud
    md-list(slot='md-expand')
      div(@click="$event.stopPropagation()")
        md-list
          template(v-for="item in hospitales")
            md-list-item.hospital(
              ref="hospitalItems"
              :key="`hospital-${item.id}`"
              :id="`hospital-${item.id}`"
              :class="item.id === institucionId ? 'selected' : ''"
              @click="setInstitucionAndUpdateRoute({ institucion: item, })")
              Institucion(:object="item")
            md-divider
  md-list-item#iglesias(md-expand :md-expanded.sync="expandIglesias")
    span.md-list-item-text Instituciones Religiosas
    md-list(slot='md-expand')
      div(@click="$event.stopPropagation()")
        md-list
          template(v-for="item in iglesias")
            md-list-item.iglesia(
              ref="iglesiaItems"
              :key="`iglesia-${item.id}`"
              :id="`iglesia-${item.id}`"
              :class="item.id === institucionId ? 'selected' : ''"
              @click="setInstitucionAndUpdateRoute({ institucion: item, })")
              Institucion(:object="item")
            md-divider
  md-list-item#centros-municipales(md-expand :md-expanded.sync="expandCentrosMunicipales")
    span.md-list-item-text Centros municipales
    md-list(slot='md-expand')
      div(@click="$event.stopPropagation()")
        CentrosMunicipales(
          :toScroll="$refs.toscroll"
          :scroll="expandCentrosMunicipales")
  md-list-item#comisarias(md-expand :md-expanded.sync="expandComisarias")
    span.md-list-item-text Comisarias
    md-list(slot='md-expand')
      div(@click="$event.stopPropagation()")
        md-list
          template(v-for="item in comisarias")
            md-list-item.comisaria(
              ref="comisariaItems"
              :key="`comisaria-${item.id}`"
              :id="`comisaria-${item.id}`"
              :class="item.id === institucionId ? 'selected' : ''"
              @click="setInstitucionAndUpdateRoute({ institucion: item, })")
              Institucion(:object="item")
            md-divider
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getData } from '@/utils/object'
import { getArray, clean } from '@/utils/array'
import { scrollElementIfExistInList } from '@/utils/dom.js'

const initialData = () => ({
  expandEscuelas: false,
  expandHospitales: false,
  expandIglesias: false,
  expandCentrosMunicipales: false,
  expandComisarias: false,
  escuelas: [],
  hospitales: [],
  iglesias: [],
  comisarias: []
})

export default {
  components: {
    CentrosMunicipales: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab2/CentrosMunicipales'),
    Institucion: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab2/Institucion')
  },
  data: () => initialData(),
  mounted () {
    this.loadData()
    this.showCentroMunicipal()
    this.showInstitucion()
  },
  methods: {
    ...mapActions(['setInstitucionAndUpdateRoute']),
    loadData () {
      this.resetData()
      getArray(this.instituciones.features).forEach(({ properties }) => {
        switch (properties.tipo_institucion) {
          case 'Comisarias':
            this.comisarias.push(properties)
            break
          case 'Instituciones Educativas':
            this.escuelas.push(properties)
            break
          case 'Instituciones de Salud':
            this.hospitales.push(properties)
            break
          default:
            this.iglesias.push(properties)
        }
      })
    },
    resetData () {
      if (!this.expandCentrosMunicipales) this.resetExpandValues()
      clean(this.comisarias)
      clean(this.escuelas)
      clean(this.hospitales)
      clean(this.iglesias)
    },
    resetExpandValues () {
      this.expandEscuelas = false
      this.expandHospitales = false
      this.expandIglesias = false
      this.expandCentrosMunicipales = false
      this.expandComisarias = false
    },
    showCentroMunicipal () {
      if (this.centroMunicipal) {
        this.resetExpandValues()
        const self = this
        setTimeout(() => {
          self.expandCentrosMunicipales = true
        })
      }
    },
    showInstitucion () {
      if (this.institucion) {
        this.resetExpandValues()
        const self = this
        setTimeout(() => {
          switch (self.institucion.tipo_institucion) {
            case 'Comisarias':
              self.expandComisarias = true
              break
            case 'Instituciones Educativas':
              self.expandEscuelas = true
              break
            case 'Instituciones de Salud':
              self.expandHospitales = true
              break
            default:
              self.expandIglesias = true
          }
          self.scrollToInstitucion()
        })
      }
    },
    scrollToInstitucion () {
      const id = this.institucion.id
      const self = this
      setTimeout(() => {
        const refs = self.$refs
        let list
        switch (self.institucion.tipo_institucion) {
          case 'Comisarias':
            list = refs.comisariaItems
            break
          case 'Instituciones Educativas':
            list = refs.escuelaItems
            break
          case 'Instituciones de Salud':
            list = refs.hospitalItems
            break
          default:
            list = refs.iglesiaItems
        }
        scrollElementIfExistInList(list, id, self.tabContentParentElement)
      }, 500)
    }
  },
  computed: {
    ...mapGetters([ 'instituciones', 'centroMunicipal', 'institucion' ]),
    tabContentParentElement () {
      return this.$parent && this.$parent.$parent && this.$parent.$parent.$el
    },
    institucionId () {
      return getData(this.institucion).id
    }
  },
  watch: {
    instituciones () {
      this.loadData()
    },
    centroMunicipal () {
      this.showCentroMunicipal()
    },
    institucion () {
      this.showInstitucion()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'
@import '~@/styles/instituciones/variables'

.instituciones-list.md-list.md-theme-default
  .md-list-item-container.md-list-item-expand
    color: $color_0
    span.md-list-item-text
      font-weight: bold
    ul
      ul
        li:not(.md-divider)
          padding: $f7px 0 $f8px 0

.md-list-item
  &.selected
    background-color: rgba(0, 0, 0, .12)
</style>
